import { useParams } from 'react-router';
import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { ReleaseDetail } from '@/components/features/release-management';

export function ReleasePage() {
  const { releaseId = '' } = useParams();

  return (
    <>
      <Meta title="Release" />

      <Container>
        <ReleaseDetail releaseId={releaseId} />
      </Container>
    </>
  );
}
